import { connect } from 'react-redux';
import EngagementPage from './EngagementPage';
import {
  currentUserId,
  sessionToken as userSessionToken,
} from '../../../../../core/selectors/user';
import { currentClassRoomId } from '../../../../../core/selectors/classroom';

const mapStateToProps = (state) => {
  const userId = currentUserId(state);
  const spaceId = currentClassRoomId(state);
  const sessionToken = userSessionToken(state);
  return {
    userId,
    spaceId,
    sessionToken,
  };
};

export default connect(mapStateToProps, null)(EngagementPage);
